import React from 'react';
import { Navigate } from 'react-router-dom';

import { extractSubscriptionPlan } from '../../pages/SubscriptionPlans/common/helper';
import { useAppSelector } from '../../redux/hooks';
import { VENUE_MANUAL_TAGS } from '../../utils/venue-tags';

type Props = {
  children: React.ReactNode;
};

export const BrandRoute: React.FC<Props> = ({ children }) => {
  const { tags: venueTags } = useAppSelector((state) => state.venue.value) || {};
  const isLoading = useAppSelector((state) => state.venue.isLoading) || {};
  const { subscription, isLoading: subscriptionLoading } = useAppSelector(
    (state) => state.subscription.value,
  );

  const subscriptionPlan = React.useMemo(() => {
    const [plan] = extractSubscriptionPlan(subscription?.sku ?? '');

    return plan;
  }, [subscription]);

  if (isLoading && subscriptionLoading) return null;

  return venueTags && venueTags?.includes(VENUE_MANUAL_TAGS.BrandPlans) && !subscriptionPlan ? (
    <Navigate to='/plans' />
  ) : (
    children
  );
};
